import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import {
	setActiveSide,
	setIdActive
} from 'components/molecules/leftSideMenu/loader'
import { CampaignSteps } from 'components/organisms/CampaingsStepCreate'
import { CampaignsHubspot } from 'components/organisms/Hubspot'
import { useLoadList } from 'features/campaigns/hooks'
import { ActivityPage } from 'pages/activityQueue'
import { SingleContactsPage } from 'pages/singleContacts'
import { Suspense } from 'react'
import { type LoaderFunction, Outlet, type RouteObject } from 'react-router-dom'

import { ArchiveCampaignsPage, CampaignsPage } from '../ListPage/ListPage'

function PageWrapper() {
	useLoadList()

	return (
		<Suspense fallback={<FullLoader />}>
			<Outlet />
		</Suspense>
	)
}

const setId: LoaderFunction = args => setIdActive(args, 'id')

async function LazyOverviewPage() {
	const { SingleOverviewPage } = await import(
		'../SingleOverview/SingleOverview'
	)

	return { Component: SingleOverviewPage }
}

export const Routes: RouteObject = {
	children: [
		{
			Component: CampaignsPage,
			loader: () => setActiveSide(1),
			path: '/campaigns'
		},
		{
			Component: ArchiveCampaignsPage,
			loader: () => setActiveSide(3),
			path: '/archive'
		},
		{
			Component: ActivityPage,
			loader: () => setActiveSide(2),
			path: '/activities-queue'
		},
		{
			lazy: LazyOverviewPage,
			loader: setId,
			path: '/archive/:id'
		},
		{
			lazy: LazyOverviewPage,
			loader: setId,
			path: '/campaigns/:id'
		},
		{
			Component: SingleContactsPage,
			loader: setId,
			path: '/campaigns/:id/contacts'
		},
		{
			Component: CampaignsHubspot,
			loader: setId,
			path: '/campaigns/:id/hubspot'
		},
		{ Component: CampaignSteps, loader: setId, path: '/campaigns/:id/tune' }
	],
	Component: PageWrapper
}
